(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			if (targetDetail.__joffzFooterBoundV61) return;
			targetDetail.__joffzFooterBoundV61 = true;
			targetDetail.addEventListener('click', () => {
				document.querySelectorAll('.footer .accordion details').forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();

})();